// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".image-container[data-v-50a2c742]{position:relative;overflow:hidden}.image-container.cover>*[data-v-50a2c742]{object-fit:cover}.image-container.contain>*[data-v-50a2c742]{object-fit:contain}.image-container:not(.keep-aspect-ratio)>*[data-v-50a2c742]{position:absolute;left:0;top:0}.image-container>*[data-v-50a2c742]{width:100%;height:100%;max-width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
